import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdditDogPage } from './addit-dog.page';
import { FormsModule } from '@angular/forms';

const routes: Routes = [
  {
    path: '',
    component: AdditDogPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), FormsModule],
  exports: [RouterModule],
})
export class AdditDogPageRoutingModule {}
